export const areaList =  [
	{
		"value": "86",
		"label": "中国 +86"
	},
	{
		"value": "852",
		"label": "中国香港特别行政区 +852"
	},
	{
		"value": "853",
		"label": "中国澳门特别行政区 +853"
	},
	{
		"value": "886",
		"label": "中国台湾地区 +886"
	},
	{
		"value": "355",
		"label": "阿尔巴尼亚 +355"
	},
	{
		"value": "213",
		"label": "阿尔及利亚 +213"
	},
	{
		"value": "93",
		"label": "阿富汗 +93"
	},
	{
		"value": "54",
		"label": "阿根廷 +54"
	},
	{
		"value": "353",
		"label": "爱尔兰 +353"
	},
	{
		"value": "20",
		"label": "埃及 +20"
	},
	{
		"value": "251",
		"label": "埃塞俄比亚 +251"
	},
	{
		"value": "372",
		"label": "爱沙尼亚 +372"
	},
	{
		"value": "971",
		"label": "阿拉伯联合酋长国 +971"
	},
	{
		"value": "297",
		"label": "阿鲁巴 +297"
	},
	{
		"value": "968",
		"label": "阿曼 +968"
	},
	{
		"value": "376",
		"label": "安道尔 +376"
	},
	{
		"value": "244",
		"label": "安哥拉 +244"
	},
	{
		"value": "1264",
		"label": "安圭拉 +1264"
	},
	{
		"value": "1268",
		"label": "安提瓜和巴布达 +1268"
	},
	{
		"value": "61",
		"label": "澳大利亚 +61"
	},
	{
		"value": "43",
		"label": "奥地利 +43"
	},
	{
		"value": "994",
		"label": "阿塞拜疆 +994"
	},
	{
		"value": "1246",
		"label": "巴巴多斯 +1246"
	},
	{
		"value": "675",
		"label": "巴布亚新几内亚 +675"
	},
	{
		"value": "1242",
		"label": "巴哈马 +1242"
	},
	{
		"value": "375",
		"label": "白俄罗斯 +375"
	},
	{
		"value": "1441",
		"label": "百慕大 +1441"
	},
	{
		"value": "92",
		"label": "巴基斯坦 +92"
	},
	{
		"value": "595",
		"label": "巴拉圭 +595"
	},
	{
		"value": "973",
		"label": "巴林 +973"
	},
	{
		"value": "507",
		"label": "巴拿马 +507"
	},
	{
		"value": "359",
		"label": "保加利亚 +359"
	},
	{
		"value": "55",
		"label": "巴西 +55"
	},
	{
		"value": "1670",
		"label": "北马里亚纳群岛 +1670"
	},
	{
		"value": "229",
		"label": "贝宁 +229"
	},
	{
		"value": "32",
		"label": "比利时 +32"
	},
	{
		"value": "354",
		"label": "冰岛 +354"
	},
	{
		"value": "267",
		"label": "博茨瓦纳 +267"
	},
	{
		"value": "1",
		"label": "波多黎各 +1"
	},
	{
		"value": "48",
		"label": "波兰 +48"
	},
	{
		"value": "591",
		"label": "玻利维亚 +591"
	},
	{
		"value": "501",
		"label": "伯利兹 +501"
	},
	{
		"value": "387",
		"label": "波斯尼亚和黑塞哥维那 +387"
	},
	{
		"value": "975",
		"label": "不丹 +975"
	},
	{
		"value": "226",
		"label": "布基纳法索 +226"
	},
	{
		"value": "257",
		"label": "布隆迪 +257"
	},
	{
		"value": "850",
		"label": "朝鲜 +850"
	},
	{
		"value": "240",
		"label": "赤道几内亚 +240"
	},
	{
		"value": "45",
		"label": "丹麦 +45"
	},
	{
		"value": "49",
		"label": "德国 +49"
	},
	{
		"value": "670",
		"label": "东帝汶 +670"
	},
	{
		"value": "228",
		"label": "多哥 +228"
	},
	{
		"value": "1767",
		"label": "多米尼加 +1767"
	},
	{
		"value": "1809",
		"label": "多米尼加共和国 +1809"
	},
	{
		"value": "593",
		"label": "厄瓜多尔 +593"
	},
	{
		"value": "291",
		"label": "厄立特里亚 +291"
	},
	{
		"value": "7",
		"label": "俄罗斯 +7"
	},
	{
		"value": "33",
		"label": "法国 +33"
	},
	{
		"value": "298",
		"label": "法罗群岛 +298"
	},
	{
		"value": "39",
		"label": "梵蒂冈 +39"
	},
	{
		"value": "689",
		"label": "法属波利尼西亚 +689"
	},
	{
		"value": "679",
		"label": "斐济 +679"
	},
	{
		"value": "63",
		"label": "菲律宾 +63"
	},
	{
		"value": "358",
		"label": "芬兰 +358"
	},
	{
		"value": "238",
		"label": "佛得角 +238"
	},
	{
		"value": "500",
		"label": "福克兰群岛 +500"
	},
	{
		"value": "220",
		"label": "冈比亚 +220"
	},
	{
		"value": "242",
		"label": "刚果（布） +242"
	},
	{
		"value": "243",
		"label": "刚果（金） +243"
	},
	{
		"value": "299",
		"label": "格陵兰 +299"
	},
	{
		"value": "1473",
		"label": "格林纳达 +1473"
	},
	{
		"value": "995",
		"label": "格鲁吉亚 +995"
	},
	{
		"value": "57",
		"label": "哥伦比亚 +57"
	},
	{
		"value": "506",
		"label": "哥斯达黎加 +506"
	},
	{
		"value": "1671",
		"label": "关岛 +1671"
	},
	{
		"value": "53",
		"label": "古巴 +53"
	},
	{
		"value": "592",
		"label": "圭亚那 +592"
	},
	{
		"value": "509",
		"label": "海地 +509"
	},
	{
		"value": "82",
		"label": "韩国 +82"
	},
	{
		"value": "7",
		"label": "哈萨克斯坦 +7"
	},
	{
		"value": "382",
		"label": "黑山共和国 +382"
	},
	{
		"value": "31",
		"label": "荷兰 +31"
	},
	{
		"value": "599",
		"label": "荷属安的列斯群岛 +599"
	},
	{
		"value": "504",
		"label": "洪都拉斯 +504"
	},
	{
		"value": "233",
		"label": "加纳 +233"
	},
	{
		"value": "1",
		"label": "加拿大 +1"
	},
	{
		"value": "855",
		"label": "柬埔寨 +855"
	},
	{
		"value": "241",
		"label": "加蓬 +241"
	},
	{
		"value": "253",
		"label": "吉布提 +253"
	},
	{
		"value": "420",
		"label": "捷克共和国 +420"
	},
	{
		"value": "996",
		"label": "吉尔吉斯斯坦 +996"
	},
	{
		"value": "686",
		"label": "基里巴斯 +686"
	},
	{
		"value": "224",
		"label": "几内亚 +224"
	},
	{
		"value": "245",
		"label": "几内亚比绍 +245"
	},
	{
		"value": "1345",
		"label": "开曼群岛 +1345"
	},
	{
		"value": "237",
		"label": "喀麦隆 +237"
	},
	{
		"value": "974",
		"label": "卡塔尔 +974"
	},
	{
		"value": "61",
		"label": "科科斯群岛 +61"
	},
	{
		"value": "385",
		"label": "克罗地亚 +385"
	},
	{
		"value": "269",
		"label": "科摩罗 +269"
	},
	{
		"value": "254",
		"label": "肯尼亚 +254"
	},
	{
		"value": "225",
		"label": "科特迪瓦 +225"
	},
	{
		"value": "965",
		"label": "科威特 +965"
	},
	{
		"value": "682",
		"label": "库克群岛 +682"
	},
	{
		"value": "266",
		"label": "莱索托 +266"
	},
	{
		"value": "856",
		"label": "老挝人民民主共和国 +856"
	},
	{
		"value": "371",
		"label": "拉脱维亚 +371"
	},
	{
		"value": "961",
		"label": "黎巴嫩 +961"
	},
	{
		"value": "231",
		"label": "利比里亚 +231"
	},
	{
		"value": "218",
		"label": "利比亚 +218"
	},
	{
		"value": "423",
		"label": "列支敦士登 +423"
	},
	{
		"value": "370",
		"label": "立陶宛 +370"
	},
	{
		"value": "40",
		"label": "罗马尼亚 +40"
	},
	{
		"value": "352",
		"label": "卢森堡 +352"
	},
	{
		"value": "250",
		"label": "卢旺达 +250"
	},
	{
		"value": "261",
		"label": "马达加斯加 +261"
	},
	{
		"value": "960",
		"label": "马尔代夫 +960"
	},
	{
		"value": "356",
		"label": "马耳他 +356"
	},
	{
		"value": "60",
		"label": "马来西亚 +60"
	},
	{
		"value": "265",
		"label": "马拉维 +265"
	},
	{
		"value": "223",
		"label": "马里 +223"
	},
	{
		"value": "44",
		"label": "曼岛 +44"
	},
	{
		"value": "230",
		"label": "毛里求斯 +230"
	},
	{
		"value": "222",
		"label": "毛里塔尼亚 +222"
	},
	{
		"value": "389",
		"label": "马其顿 +389"
	},
	{
		"value": "692",
		"label": "马绍尔群岛 +692"
	},
	{
		"value": "262",
		"label": "马约特 +262"
	},
	{
		"value": "1",
		"label": "美国 +1"
	},
	{
		"value": "1684",
		"label": "美属萨摩亚 +1684"
	},
	{
		"value": "1340",
		"label": "美属维京群岛 +1340"
	},
	{
		"value": "976",
		"label": "蒙古 +976"
	},
	{
		"value": "880",
		"label": "孟加拉国 +880"
	},
	{
		"value": "1664",
		"label": "蒙塞拉特群岛 +1664"
	},
	{
		"value": "95",
		"label": "缅甸 +95"
	},
	{
		"value": "691",
		"label": "密克罗尼西亚联邦 +691"
	},
	{
		"value": "51",
		"label": "秘鲁 +51"
	},
	{
		"value": "373",
		"label": "摩尔多瓦 +373"
	},
	{
		"value": "212",
		"label": "摩洛哥 +212"
	},
	{
		"value": "377",
		"label": "摩纳哥 +377"
	},
	{
		"value": "258",
		"label": "莫桑比克 +258"
	},
	{
		"value": "52",
		"label": "墨西哥 +52"
	},
	{
		"value": "264",
		"label": "纳米比亚 +264"
	},
	{
		"value": "27",
		"label": "南非 +27"
	},
	{
		"value": "672",
		"label": "南极洲 +672"
	},
	{
		"value": "674",
		"label": "瑙鲁 +674"
	},
	{
		"value": "977",
		"label": "尼泊尔 +977"
	},
	{
		"value": "505",
		"label": "尼加拉瓜 +505"
	},
	{
		"value": "227",
		"label": "尼日尔 +227"
	},
	{
		"value": "234",
		"label": "尼日利亚 +234"
	},
	{
		"value": "683",
		"label": "纽埃 +683"
	},
	{
		"value": "47",
		"label": "挪威 +47"
	},
	{
		"value": "680",
		"label": "帕劳 +680"
	},
	{
		"value": "870",
		"label": "皮特凯恩群岛 +870"
	},
	{
		"value": "351",
		"label": "葡萄牙 +351"
	},
	{
		"value": "81",
		"label": "日本 +81"
	},
	{
		"value": "46",
		"label": "瑞典 +46"
	},
	{
		"value": "41",
		"label": "瑞士 +41"
	},
	{
		"value": "503",
		"label": "萨尔瓦多 +503"
	},
	{
		"value": "381",
		"label": "塞尔维亚 +381"
	},
	{
		"value": "232",
		"label": "塞拉利昂 +232"
	},
	{
		"value": "221",
		"label": "塞内加尔 +221"
	},
	{
		"value": "357",
		"label": "塞浦路斯 +357"
	},
	{
		"value": "248",
		"label": "塞舌尔群岛 +248"
	},
	{
		"value": "685",
		"label": "萨摩亚 +685"
	},
	{
		"value": "966",
		"label": "沙特阿拉伯 +966"
	},
	{
		"value": "590",
		"label": "圣巴泰勒米 +590"
	},
	{
		"value": "61",
		"label": "圣诞岛 +61"
	},
	{
		"value": "239",
		"label": "圣多美和普林西比 +239"
	},
	{
		"value": "290",
		"label": "圣赫勒拿 +290"
	},
	{
		"value": "1869",
		"label": "圣基茨和尼维斯 +1869"
	},
	{
		"value": "1758",
		"label": "圣卢西亚 +1758"
	},
	{
		"value": "1599",
		"label": "圣马丁 +1599"
	},
	{
		"value": "378",
		"label": "圣马力诺 +378"
	},
	{
		"value": "508",
		"label": "圣皮埃尔和密克隆 +508"
	},
	{
		"value": "1784",
		"label": "圣文森特和格林纳丁斯 +1784"
	},
	{
		"value": "94",
		"label": "斯里兰卡 +94"
	},
	{
		"value": "421",
		"label": "斯洛伐克 +421"
	},
	{
		"value": "386",
		"label": "斯洛文尼亚 +386"
	},
	{
		"value": "268",
		"label": "斯威士兰 +268"
	},
	{
		"value": "249",
		"label": "苏丹 +249"
	},
	{
		"value": "677",
		"label": "所罗门群岛 +677"
	},
	{
		"value": "252",
		"label": "索马里 +252"
	},
	{
		"value": "66",
		"label": "泰国 +66"
	},
	{
		"value": "992",
		"label": "塔吉克斯坦 +992"
	},
	{
		"value": "676",
		"label": "汤加 +676"
	},
	{
		"value": "255",
		"label": "坦桑尼亚 +255"
	},
	{
		"value": "1649",
		"label": "特克斯和凯科斯群岛 +1649"
	},
	{
		"value": "1868",
		"label": "特立尼达和多巴哥 +1868"
	},
	{
		"value": "90",
		"label": "土耳其 +90"
	},
	{
		"value": "993",
		"label": "土库曼斯坦 +993"
	},
	{
		"value": "216",
		"label": "突尼斯 +216"
	},
	{
		"value": "690",
		"label": "托克劳 +690"
	},
	{
		"value": "688",
		"label": "图瓦卢 +688"
	},
	{
		"value": "681",
		"label": "瓦利斯和富图纳 +681"
	},
	{
		"value": "678",
		"label": "瓦努阿图 +678"
	},
	{
		"value": "502",
		"label": "危地马拉 +502"
	},
	{
		"value": "58",
		"label": "委内瑞拉 +58"
	},
	{
		"value": "673",
		"label": "文莱 +673"
	},
	{
		"value": "256",
		"label": "乌干达 +256"
	},
	{
		"value": "380",
		"label": "乌克兰 +380"
	},
	{
		"value": "598",
		"label": "乌拉圭 +598"
	},
	{
		"value": "998",
		"label": "乌兹别克斯坦 +998"
	},
	{
		"value": "34",
		"label": "西班牙 +34"
	},
	{
		"value": "30",
		"label": "希腊 +30"
	},
	{
		"value": "65",
		"label": "新加坡 +65"
	},
	{
		"value": "687",
		"label": "新喀里多尼亚 +687"
	},
	{
		"value": "64",
		"label": "新西兰 +64"
	},
	{
		"value": "36",
		"label": "匈牙利 +36"
	},
	{
		"value": "963",
		"label": "叙利亚 +963"
	},
	{
		"value": "1876",
		"label": "牙买加 +1876"
	},
	{
		"value": "374",
		"label": "亚美尼亚 +374"
	},
	{
		"value": "967",
		"label": "也门 +967"
	},
	{
		"value": "39",
		"label": "意大利 +39"
	},
	{
		"value": "964",
		"label": "伊拉克 +964"
	},
	{
		"value": "98",
		"label": "伊朗 +98"
	},
	{
		"value": "91",
		"label": "印度 +91"
	},
	{
		"value": "62",
		"label": "印度尼西亚 +62"
	},
	{
		"value": "44",
		"label": "英国 +44"
	},
	{
		"value": "1284",
		"label": "英属维京群岛 +1284"
	},
	{
		"value": "972",
		"label": "以色列 +972"
	},
	{
		"value": "962",
		"label": "约旦 +962"
	},
	{
		"value": "84",
		"label": "越南 +84"
	},
	{
		"value": "260",
		"label": "赞比亚 +260"
	},
	{
		"value": "235",
		"label": "乍得 +235"
	},
	{
		"value": "350",
		"label": "直布罗陀 +350"
	},
	{
		"value": "56",
		"label": "智利 +56"
	},
	{
		"value": "236",
		"label": "中非共和国 +236"
	}
]


// WEBPACK FOOTER //
// ./src/utils/area_zh_CN.js